import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {CurrentUserService} from '@shared/services/current-user.service';
import {map} from 'rxjs/operators';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {NotificationService} from '@shared/services/notification.service';
import {ROUTES as PAGE_ROUTE} from '@modules/pages/page-routing.module';

@Injectable({
  providedIn: 'root'
})
export class AccessMenuGuard implements CanActivate {

  constructor(
    private currentUserService: CurrentUserService,
    private notiService: NotificationService,
    private router: Router
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): any {
    return this.checkUserAccess(route.data?.canActive);
  }

  checkUserAccess(menuCode: string) {
    if (!menuCode) return true;
    return this.currentUserService.canAccessMenu(menuCode).pipe(
      map((res: BaseResponse<any, any>) => {
        if (res?.messageCode == MESSAGE_CODE.SUCCESS && res.data.canActive) return true;
        else {
          this.router.navigateByUrl([PAGE_ROUTE.PREFIX, PAGE_ROUTE['403']].join("/")).then();
          return false;
        }
      }),
    )
  }

}
